import styled from 'styled-components/macro';
import Google from 'icons/Google.svg';
import { COLORS, TYPOGRAPHY } from 'styleguide';
import GoogleLogin from 'react-google-login';

const GoogleLoginStyled = styled(GoogleLogin)`
  position: relative;
  padding: 6px 75px !important;
  border-radius: 3px !important;
  border: 2px solid #fff !important;
  background-color: #fff;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease-out;

  span {
    ${TYPOGRAPHY.bodySemibold}
    color: ${COLORS.black};
  }

  &:active,
  &:hover,
  &:focus {
    border-color: ${COLORS.primary};
  }

  &:disabled {
    opacity: 0.3;
    cursor: default;
  }

  &::before {
    position: absolute;
    top: 10px;
    left: 20px;
    content: '';
    width: 32px;
    height: 33px;
    background-image: url(${Google});
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export default GoogleLoginStyled;
